/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */

/* eslint hubspot-dev/hubspot-is-special: 0 */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom'; //I18n Configuration

import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import registerBasicData from 'I18n/init/register/lazy/registerBasicData';
import lang from 'i2l?query=sporks!../lang/en.lyaml'; // Configure redux

import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import configureStore from './lib/configureStore'; // Configure the router

import { Router } from 'react-router-dom';
import routes from './routes';
import { getRootUrl } from './utils/urls';
import createHistory from './utils/createHistory';
import * as LoginUtils from './lib/LoginUtils';
import removeBackUpPageNotLoading from './utils/removeBackUpPageNotLoading';
import FireAlarmApp from 'FireAlarmUi/js/FireAlarmApp'; // React-rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
export default class Application {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createPublicI18nProvider();
    const langAvailable = Promise.all([I18nProvider.register(lang), registerBasicData(I18nProvider)]);
    this.startRedux();
    langAvailable.then(() => {
      this.startRouter();
      this.startFireAlarm();
    });
    removeBackUpPageNotLoading();
  }

  startFireAlarm() {
    const fireAlarm = new FireAlarmApp(window.hubspot, {
      appName: 'LoginUI',
      containers: {
        default: {
          parent: document.body,
          before: document.getElementsByClassName('page')[0]
        }
      }
    });
    window.hubspot[FireAlarmApp.HUBSPOT_FIREALARM_KEY] = fireAlarm;
    fireAlarm.start();
  }

  startRedux() {
    this.store = configureStore([thunk]);
  }

  startRouter() {
    const history = createHistory({
      rootUrl: getRootUrl(),
      source: LoginUtils.getLoginSource()
    });
    render( /*#__PURE__*/_jsx(Provider, {
      store: this.store,
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: routes
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}